<template>
  <div class="col-lg-2 col-md-3 col-sm-12" role="complementary">
    <div id="sticky-menu-container">
      <div class="sticky-side-menus" role="complementary">
        <div class="vehicle-filter-menu hidden-sm hidden-xs" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
          <div class="panel panel-default filter-panel">
            <div
              aria-level="2"
              class="panel-heading text-center hidden-sm hidden-xs"
              role="heading"
              :style="`background: ${headerColor}`"
            >
              Refine Results
            </div>
            <div class="panel-body sort-menu-container">
              <form class="search-bar-mini" v-if="brand.toLowerCase() === 'mazda'">
                <div class="input-group">
                  <input class="form-control" name="query" placeholder="Search" type="text">
                  <span class="input-group-btn">
                    <button class="btn btn-default no-border-left" type="submit">
                      <i class="fa fa-search"></i>
                    </button>
                  </span>
                </div>
              </form>
              <div class="filter-section">
                <div class="filter-list">
                  <a
                    v-for="filter in filterNames"
                    :key="`filter-${filter}`"
                    aria-expanded="false"
                    class="filter-button section-heading"
                    href="#"
                  >
                    {{ filter }}
                    <i aria-hidden="true" class="fa selected-icon fa-plus"></i>
                  </a>
                </div>
              </div>
              <a
                class="section-heading hidden-xs hidden-sm back-to-top"
                href="#"
                onclick="$(window).scroll(0); $(&#39;#desktop-logo a&#39;).focus();"
              >
                <i class="fa fa-arrow-up"> </i><span>&nbsp; Back to Top</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideFilterMenu",
  props: {
    headerColor: {
      type: String,
      required: true,
    },
    brand: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      filterNames: [
        'Year',
        'Make',
        'Model',
        'Trim',
        'Color',
        'Vehicle Type',
        'Body Type',
        'Drive',
        'Fuel Type',
        'Transmission',
        'Price',
        'Options',
        'Mileage'
      ],
    }
  }
};
</script>

<style scoped>
.filter-select-btn {
  white-space: normal;
  border: none;
}

.listing-page {
  background: #f0f0f0 !important;
  min-height: 400px;
}

.vehicle-filter-menu {
  max-height: 90%;
  overflow: hidden;
  width: inherit !important;
}
.vehicle-filter-menu .section-divider {
  border-bottom: 1px #ccc solid;
  min-height: 1px;
  clear: both;
  width: 100%;
  height: 1px;
}
.vehicle-filter-menu a.section-heading {
  display: block;
  color: #333333;
  font-size: 17px;
  padding: 2px 0 4px 10px;
  margin: 4px 0 4px 0;
  border-bottom: 1px #eee solid;
}
.vehicle-filter-menu a.section-heading:last-of-type {
  border-bottom: none;
}
.vehicle-filter-menu a.section-heading:hover,
.vehicle-filter-menu a.section-heading:active,
.vehicle-filter-menu a.section-heading:visited,
.vehicle-filter-menu a.section-heading:focus {
  text-decoration: none;
}
.vehicle-filter-menu a.section-heading .selected-icon {
  float: right;
  padding-right: 10px;
  color: #333333;
}
.vehicle-filter-menu:hover,
.vehicle-filter-menu:active,
.vehicle-filter-menu:visited,
.vehicle-filter-menu:focus {
  text-decoration: none;
}
.vehicle-filter-menu .section-color,
.vehicle-filter-menu .section-interior_color {
  text-transform: capitalize;
}
.vehicle-filter-menu .filter-section-mileage .filter-list,
.vehicle-filter-menu .filter-section-price .filter-list {
  padding-left: 18px;
  padding-right: 18px;
}
.vehicle-filter-menu .filter-section-mileage .filter-list .irs,
.vehicle-filter-menu .filter-section-price .filter-list .irs {
  padding: 0;
}
.vehicle-filter-menu .filter-list {
  min-height: 390px;
  overflow: hidden;
  padding: 5px 0;
}
.vehicle-filter-menu .filter-list .irs {
  padding: 2px 18px 0 0;
}
.vehicle-filter-menu .filter-list label {
  display: block;
  padding: 3px 0 0 20px;
  font-weight: 400;
}
.vehicle-filter-menu .filter-list input {
  margin-right: 8px;
}
.sort-menu-container > form.search-bar-mini {
    margin-bottom: 10px;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini input {
  border-right: 0px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .input-group {
    position: relative;
    display: table;
    border-collapse: separate;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .form-control,
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .input-group-btn {
  display: table-cell;
    width: 100%;
    height: 34px;
    
    font-size: 14px;
    line-height: 1.428571429;
    color: #555555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 0px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,0.075);
    -webkit-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .form-control {
  padding: 6px 12px;
  border-right: none;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .input-group-btn {
    position: relative;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
    border-left: none;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
}
.vehicle-index-container .listing-page .vehicle-filter-menu form.search-bar-mini .input-group-btn .btn-default {
    border: none;
    font-size: 13px;
    padding: 6px 12px;
}

@media (min-width: 992px) {
  .vehicles-found-container h1 {
    font-size: 20px;
  }
  .vehicles-found-container div {
    font-size: 18px;
  }
  .vehicle-filter-menu,
  .vehicle-search-menu {
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
  }
  .vehicle-filter-menu .sort-menu,
  .vehicle-search-menu .sort-menu {
    top: 95%;
  }
  .vehicle-filter-menu .no-padding,
  .vehicle-search-menu .no-padding {
    padding: 0;
  }
  .vehicle-filter-menu .panel,
  .vehicle-search-menu .panel {
    border-radius: 0;
    margin-bottom: 0;
  }
  .vehicle-filter-menu .panel .panel-heading,
  .vehicle-search-menu .panel .panel-heading {
    border-radius: 0;
    font-size: 18px;
    color: #ffffff;
    background-color: red;
    background-image: none;
    padding: 12px 15px;
  }
  .vehicle-filter-menu .panel .panel-body,
  .vehicle-search-menu .panel .panel-body {
    padding: 0 10px 50px;
  }
  .vehicle-filter-menu .panel .panel-footer,
  .vehicle-search-menu .panel .panel-footer {
    padding: 0 15px;
  }
  .vehicle-filter-menu .panel .btn,
  .vehicle-search-menu .panel .btn {
    border-radius: 0;
  }
}

.sort-menu-container {
  overflow-y: auto;
  position: relative;
}
.sort-menu-container .filter-selected {
  width: 80%;
  float: left;
}
.sort-menu-container .remove-filter {
  margin-top: 4px;
  cursor: pointer;
}
</style>